import { render, staticRenderFns } from "./UsersDetail.vue?vue&type=template&id=6cf0c217&scoped=true"
import script from "./UsersDetail.vue?vue&type=script&lang=js"
export * from "./UsersDetail.vue?vue&type=script&lang=js"
import style0 from "./UsersDetail.vue?vue&type=style&index=0&id=6cf0c217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf0c217",
  null
  
)

export default component.exports